// http://localhost:3000/product/adjustable-aluminum-configurable-spiral-stair/?sku=ST3609SBAA&post=870
// http://localhost:3000/product/econo-plus-configurable-spiral-stair/?sku=SV3609BSNA1&post=980
// http://localhost:3000/product/forged-iron-configurable-spiral-stair/?sku=SF3609SSNDAN&post=982

import AdjustableAluminumBuilder from './class-adjustable-aluminum';
import EconPlusBuilder from './class-econ-plus';
import ForgedIronBuilder from './class-forged-iron';
import AllWoodBuilder from './class-all-wood';
import AluminumBuilder from './class-aluminum';
import CompressionBuilder from './class-compression';
import EconomyBuilder from './class-economy';
import GalvanizedBuilder from './class-galvanized';
import SteelBuilder from './class-steel';

var form_init = false,
    builder_init = false,
    query = window.location.search.substring(1),
    builder;

function builderInit() {
  if (form_init && builder_init) {
    builder.update();
  }
}

$('.composite_data').on('wc-composite-initializing', function(event, composite) {
  composite.actions.add_action('composite_initialized', function() {
    builder_init = true;
    builder = setBuilder(query);

    builderInit();
  }, 30);

  composite.actions.add_action('component_selection_changed', function() {
    builderInit();
  }, 30);
});

$(document).on('gform_post_render', function(event, form_id) {
  if ($('#gform_wrapper_' + form_id).hasClass('builder-form_wrapper')) {
    form_init = true;

    builderInit();
  }
});

function setBuilder(query) {
  var body_classes = $('body')[0].classList;

  $.each(body_classes, function(i, item) {
    switch(item) {
      case 'adjustable-aluminum-configurable-spiral-stair':
        builder = new AdjustableAluminumBuilder(query);
        console.log('Adjustable Aluminum Settings Loaded...');
        break;

      case 'econo-plus-configurable-spiral-stair':
        builder = new EconPlusBuilder(query);
        console.log('Econo Plus Settings Loaded...');
        break;

      case 'forged-iron-configurable-spiral-stair':
        builder = new ForgedIronBuilder(query);
        console.log('Forged Iron Settings Loaded...')
        break;

      case 'aluminum-configurable-spiral-stair':
        builder = new AluminumBuilder(query);
        console.log('Aluminum Settings Loaded...')
        break;

      case 'steel-configurable-spiral-stair':
        builder = new SteelBuilder(query);
        console.log('Steel Settings Loaded...')
        break;

      case 'economy-configurable-spiral-stair':
        builder = new EconomyBuilder(query);
        console.log('Economy Settings Loaded...')
        break;

      case 'compression-configurable-spiral-stair':
        builder = new CompressionBuilder(query);
        console.log('Compression Settings Loaded...')
        break;

      case 'galvanized-configurable-spiral-stair':
        builder = new GalvanizedBuilder(query);
        console.log('Galvanized Settings Loaded...')
        break;

      case 'all-wood-configurable-spiral-stair':
        builder = new AllWoodBuilder(query);
        console.log('All Wood Settings Loaded...')
        break;
    }
  });

  return builder;
}







